import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Header } from 'semantic-ui-react';
import { sysAPI } from '../../../../apis/SysAPI';
import { responseError } from '../../../../helpers';
import { useDispatch } from 'react-redux';
import TableFpAlpha from '../../../../components/Table';
import Loading from '../../../../components/globals/Loading';

const ReasonOfFailure = forwardRef(({ activeIndex, startDate, endDate, areas, loading, excludeCompanies, includeCompanies, setLoading }, ref) => {
    const dispatch = useDispatch();
    const [info, setInfo] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [internalLoading, setIntenalLoading] = useState(false)

    const getData = async () => {
        setLoading(true);
        setIntenalLoading(true);
        try {
            const { data } = await sysAPI.get(`/metrics/tables/reason-of-failure`, {
                params: {
                    startDate,
                    endDate,
                    areas: areas.join(','),
                    excludeCompanies: excludeCompanies.join(','),
                    includeCompanies: includeCompanies.join(','),
                },
            });
            setInfo(data?.data?.items || []);
            setHeaders(data?.data?.headers || []);
        } catch (error) {
            responseError(error, undefined, 'ReasonOfFailure.getData', dispatch);
        }
        setLoading(false);
        setIntenalLoading(false);
    };

    useImperativeHandle(ref, () => ({
        getData: getData,
    }));

    useEffect(() => {
        getData();

        // eslint-disable-next-line
    }, [activeIndex]);

    return (
        <div className='card_metrics'>
            {internalLoading ? <>
                <Loading />
            </> : <>
            <Header textAlign="center" as="h3">
                Reason Of Failure
            </Header>
            <div>
                <TableFpAlpha
                    headers={headers}
                    data={info}
                    positionHeaders='center'
                >
                    {headers.filter(h => h.isDynamic).map((header, index) => (
                        <div slot={header.value} render={({ data }) => (
                            <>{data[header.value] || 0} ({data[header.value+"_percentage"] || 0}%)</>
                        )} />
                    ))}
                </TableFpAlpha>
            </div>
            </>}
        </div>
    );
});

export default ReasonOfFailure;
